const R = 68
const CX = 95
const CY = 98
const START_DEG = 205
const END_DEG = -25
const SWEEP_DEG = START_DEG - END_DEG

function pointOnArc(deg: number) {
  const rad = (deg * Math.PI) / 180
  return {
    x: CX + R * Math.cos(rad),
    y: CY - R * Math.sin(rad),
  }
}

function arcPath(fromDeg: number, toDeg: number) {
  const from = pointOnArc(fromDeg)
  const to = pointOnArc(toDeg)
  const largeArcFlag = fromDeg - toDeg > 180 ? 1 : 0
  return `M ${from.x} ${from.y} A ${R} ${R} 0 ${largeArcFlag} 1 ${to.x} ${to.y}`
}

export function Gauge({ score, color }: { score: number; color: string }) {
  const scoreDeg = START_DEG - SWEEP_DEG * (score / 100)

  return (
    <svg
      width="180"
      height="160"
      viewBox="0 0 190 155"
      role="img"
      aria-label={`FundReady™ score ${score} out of 100`}
    >
      <path
        d={arcPath(START_DEG, END_DEG)}
        fill="none"
        className="stroke-fr-border"
        strokeWidth="15"
        strokeLinecap="round"
      />
      {score > 0 && (
        <path
          d={arcPath(START_DEG, scoreDeg)}
          fill="none"
          style={{ stroke: color }}
          strokeWidth="15"
          strokeLinecap="round"
        />
      )}
      <text
        x={CX}
        y={CY + 6}
        textAnchor="middle"
        fontSize="44"
        fontWeight="800"
        className="fill-fr-ink"
      >
        {score}
      </text>
      <text
        x={CX}
        y={CY + 34}
        textAnchor="middle"
        fontSize="15"
        fontWeight="400"
        className="fill-fr-muted"
        letterSpacing="0.05em"
      >
        / 100
      </text>
    </svg>
  )
}
